<template>
	<div>
		<input v-for="btn in list" type="button" :value="btn.name" @click="click(btn.url)">
	</div>
</template>

<script>
	export default {
		name: 'Tese',
		data() {
			return {
				list: [
					{name:'钻石捐赠',fn:'',param:'',url:'http://laia-common.yeedian365.com/laia_h5/index.html#/TestDiamondDonation'},
					{name:'钻石明细',fn:'',param:'',url:'http://laia-common.yeedian365.com/laia_h5/index.html#/TestDiamondDonationRecord'},
				],
			}
		},
		methods: {
			click(url){
        window.LaiaJs.openUrl(url);
			}
		}
	}
</script>

<style scoped>
	input{
		width: 90%;
		height: 1rem;
		font-size: 0.4rem;
		color: #fff;
		border-radius: 0.1rem;
		background: #2E74FB;
		display: block;
		margin: 0 auto;
		margin-top: 0.4rem;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Test.vue